/**
 * Generated by orval v8.16.0 🍺
 * Do not edit manually.
 * FinPath API
 * Backend API programu FinPath (panel admina + aplikacja mobilna).
 * OpenAPI spec version: 0.1.0
 */

/**
 * * `display` - Błąd wyświetlania
 * * `data` - Błędne dane
 * * `login` - Problem z logowaniem
 * * `performance` - Problem z wydajnością
 * * `other` - Inne
 */
export type BugReportSubjectEnum = typeof BugReportSubjectEnum[keyof typeof BugReportSubjectEnum];


export const BugReportSubjectEnum = {
  display: 'display',
  data: 'data',
  login: 'login',
  performance: 'performance',
  other: 'other',
} as const;
